
import axios from 'axios'

export default class HAppService {

  // name: 'HAppService',
  constructor() {

  }

  post (hApp) {
    this.token = JSON.parse(sessionStorage.getItem('token'))

    console.log('hAppService Post')
    console.log(hApp)

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        'url': `${ENV.server_back}/api/happs`,
        'data': JSON.stringify(hApp),
        'headers': {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': this.token.token_type + ' ' + this.token.access_token
        }
      })
        .then(response => {
          resolve(response.data)
        }, response => {
          reject(response.data)
        })
    })
  }
}




// WEBPACK FOOTER //
// ./src/services/HAppService.js